import React, { Component } from 'react'
import Button from '~/Common-Objects/UI/Forms/Button/Button'
import Icons from '~/Common-Objects/UI/Icons/index'
import TextInput from '~/Common-Objects/UI/Forms/TextInput/TextInput'
import MPZLinkPicker from './LinkPicker.jsx'

function asItems(value) {
    if (Array.isArray(value)) return value
    return []
}

export default class MenuLinks extends Component {
    constructor(props) {
        super(props)

        this.state = {
            value: asItems(props.value),
            draggedIndex: null,
            dragging: false,
            dragOverIndex: null,
            insertPosition: 'bottom'
        }
        this.addValue = this.addValue.bind(this)
        this.removeVal = this.removeVal.bind(this)
        this.changeLabel = this.changeLabel.bind(this)
        this.changeLink = this.changeLink.bind(this)
        this.processIncoming = this.processIncoming.bind(this)
        this.handleDragStart = this.handleDragStart.bind(this)
        this.handleDragEnter = this.handleDragEnter.bind(this)
        this.handleDragLeave = this.handleDragLeave.bind(this)
        this.handleDrop = this.handleDrop.bind(this)
        this.handleDragEnd = this.handleDragEnd.bind(this)
    }

    componentDidMount() {
        this.processIncoming(this.props)
    }

    componentWillReceiveProps(nextProps) {
        this.processIncoming(nextProps)
    }

    processIncoming(props) {
        this.setState({ value: asItems(props.value) })
    }

    commit(theVals) {
        this.setState({ value: theVals })
        this.props.updateVal(this.props.path, theVals)
    }

    addValue() {
        const theVals = this.state.value.slice()
        theVals.push({ label: '', value: '' })
        this.commit(theVals)
    }

    removeVal(index) {
        const theVals = this.state.value.slice()
        theVals.splice(index, 1)
        this.commit(theVals)
    }

    changeLabel(event, index) {
        const theVals = this.state.value.slice()
        let currVal = theVals[index]
        if (typeof currVal != 'object') currVal = { value: currVal, label: currVal }
        currVal = { ...currVal, label: event.target.value }
        theVals[index] = currVal
        this.commit(theVals)
    }

    changeLink(index, url) {
        const theVals = this.state.value.slice()
        let currVal = theVals[index]
        if (typeof currVal != 'object') currVal = { value: currVal, label: currVal }
        currVal = { ...currVal, value: url || '' }
        theVals[index] = currVal
        this.commit(theVals)
    }

    handleDragStart = (index) => {
        this.setState({
            draggedIndex: index,
            dragging: true
        })
    }

    handleDragEnter = (index, e) => {
        if (this.state.draggedIndex !== null && this.state.draggedIndex !== index) {
            const rect = e.currentTarget.getBoundingClientRect()
            const mouseY = e.clientY
            const elementMiddle = rect.top + rect.height / 2
            this.setState({
                dragOverIndex: index,
                insertPosition: mouseY < elementMiddle ? 'top' : 'bottom'
            })
        }
    }

    handleDragLeave = (e) => {
        if (!e.currentTarget.contains(e.relatedTarget)) {
            this.setState({ dragOverIndex: null })
        }
    }

    handleDrop = (e, dropIndex) => {
        e.preventDefault()
        e.stopPropagation()
        const { draggedIndex, insertPosition } = this.state

        if (draggedIndex === null || draggedIndex === dropIndex) {
            this.handleDragEnd()
            return
        }

        const theVals = this.state.value.slice()
        const draggedItem = theVals[draggedIndex]
        theVals.splice(draggedIndex, 1)
        let insertIndex
        if (insertPosition === 'top') {
            insertIndex = draggedIndex < dropIndex ? dropIndex - 1 : dropIndex
        } else {
            insertIndex = draggedIndex < dropIndex ? dropIndex : dropIndex + 1
        }
        theVals.splice(insertIndex, 0, draggedItem)
        this.commit(theVals)
        this.handleDragEnd()
    }

    handleDragEnd = () => {
        this.setState({
            draggedIndex: null,
            dragging: false,
            dragOverIndex: null,
            insertPosition: 'bottom'
        })
    }

    render() {
        var style = {}
        if (this.props.elementData && this.props.elementData.optionFullWidth) style = { flex: '100%' }

        let title = this.props.title
        if (this.props.elementData && this.props.elementData.hasOwnProperty('labelNew')) {
            title = this.props.elementData.labelNew
        }

        return (
            <div className='dndEditorv2-dd_toolHolder ' style={style}>
                <div className='dd_inputTool'>
                    {title && <p className='txtInput_label'>{title}</p>}

                    {this.state.value.length > 0 && (
                        <div className='mar-b15'>
                            {this.state.value.map((theVal, index) => {
                                var theValue = ''
                                var theLabel = ''

                                if (typeof theVal == 'object' && theVal != null) {
                                    theValue = theVal.value
                                    theLabel = theVal.label
                                } else {
                                    theValue = theVal
                                    theLabel = theVal
                                }

                                let outerStyle = {}
                                if (this.state.dragging && this.state.draggedIndex === index) {
                                    outerStyle.opacity = 0.5
                                }

                                return (
                                    <div
                                        key={'menu-link-' + index}
                                        style={outerStyle}
                                        className='dndEditorv2-dd_subToolOptionHolder'
                                        draggable={true}
                                        onDragStart={(e) => {
                                            e.dataTransfer.effectAllowed = 'move'
                                            e.dataTransfer.setData('text/html', index.toString())
                                            e.stopPropagation()
                                            this.handleDragStart(index)
                                        }}
                                        onDragEnter={(e) => this.handleDragEnter(index, e)}
                                        onDragLeave={(e) => this.handleDragLeave(e)}
                                        onDragOver={(e) => {
                                            e.preventDefault()
                                            e.stopPropagation()
                                            e.dataTransfer.dropEffect = 'move'
                                            this.handleDragEnter(index, e)
                                        }}
                                        onDrop={(e) => {
                                            e.stopPropagation()
                                            this.handleDrop(e, index)
                                        }}
                                        onDragEnd={this.handleDragEnd}
                                    >
                                        <div style={{ flex: 0 }}>
                                            <Icons
                                                icon='drag'
                                                color='#666'
                                                style={{ height: 16, width: 16, cursor: 'move' }}
                                            />
                                        </div>
                                        <div style={{ flex: 1, display: 'flex', flexDirection: 'column', gap: 8 }}>
                                            <TextInput
                                                label='Link text'
                                                type='text'
                                                value={theLabel || ''}
                                                name='label'
                                                placeHolder='Home'
                                                onChange={(event) => {
                                                    this.changeLabel(event, index)
                                                }}
                                            />
                                            <MPZLinkPicker
                                                save={(url) => this.changeLink(index, url)}
                                                currVal={theValue || ''}
                                                close={() => {}}
                                                toggleHidePickers={() => {}}
                                                elementsData={this.props.elementsData}
                                                inline={true}
                                                isLandingPage={this.props.isLandingPage}
                                            />
                                        </div>
                                        <div style={{ flex: 0 }}>
                                            <Icons
                                                icon='bin'
                                                onClick={() => {
                                                    this.removeVal(index)
                                                }}
                                                color='#DD4340'
                                                style={{ height: 16, width: 16 }}
                                            />
                                        </div>
                                    </div>
                                )
                            })}
                        </div>
                    )}

                    <div style={{ display: 'flex', gap: '10px', alignItems: 'center' }}>
                        <Button
                            text='Add link'
                            onClick={this.addValue}
                            className='button-sml button-primary'
                            iconLeft={<Icons icon='plus' />}
                        />
                    </div>
                </div>
            </div>
        )
    }
}
